import { useEffect, useState } from "react";
import { initialize } from "../../oauth/Oauth";
import { checkCurrentStatus, signIn, signOut } from "../../oauth/Oauth";
import Portal from "@arcgis/core/portal/Portal";
import { useNavigate } from "react-router-dom";
import esriConfig from "@arcgis/core/config";
import UseMsalLogin from "../msal/UseMsalLogin";

const UseOath = ({ esriOauthAppId, mapPublic, portalURL, mapId,apiKey,useMsalLogin }) => {
  const [portal, setPortal] = useState("");
  const [credential, setCredential] = useState("");
  const [oauthChecked, setOauthChecked] = useState(false);
  const [msalLoginInUser, setMsalLoginInUser] = useState(false);
  const navigate = useNavigate();

  const msalChecked = UseMsalLogin(msalLoginInUser);

  useEffect(() => {
    //sessionStorage.removeItem("esriJSAPIOAuth")
    //sessionStorage.clear()
    if(portalURL){
    esriConfig.portalUrl = portalURL;
    }
  }, [portalURL]);

  useEffect(() => {
    if(mapPublic && portalURL){
      if(apiKey){
        setApiKey(apiKey)
      }
      mapPublicHandler(portalURL,setPortal,setOauthChecked)
    }
  }, [mapPublic,portalURL,apiKey]);

  useEffect(() => {
    if(!mapPublic && portalURL ){
    checkCredentials(
      mapPublic,
      setCredential,
      portalURL,
      esriOauthAppId,
      navigate
    );
    }
  }, [mapPublic, portalURL, esriOauthAppId, portal]);

  useEffect(() => {
    if(!mapPublic && mapId && portalURL){
    credentialHandler(
      credential,
      setPortal,
      setOauthChecked,
      mapPublic,
      mapId,
      navigate,
      portalURL
    );
    }
  }, [credential, mapPublic,mapId,portalURL]);

  useEffect(() => {
    if(!mapPublic && mapId && portalURL && oauthChecked && useMsalLogin){
      setMsalLoginInUser(true)
      }

  }, [oauthChecked,useMsalLogin,mapPublic,mapId,portalURL]);

  useEffect(()=>{
    if(msalChecked){
      console.log("msalChecked")

    }
  },[msalChecked])

  return [portal, oauthChecked];
};

export default UseOath;

const mapPublicHandler = async(portalURL,setPortal,setOauthChecked)=>{
  const portalT = new Portal({ url: portalURL });
  await portalT.load();
  setPortal(portalT);
  setOauthChecked(true);
 // setCredential("");
}

const credentialHandler = async (
  credential,
  setPortal,
  setOauthChecked,
  mapPublic,
  mapId,
  navigate,
  portalURL
) => {
  if (credential) {
    const portalT = new Portal({ url: portalURL });
    await portalT.load();
    let queryParams = {
      query: `id:${mapId}`,
      num: 1,
    };
    let portalItemReturn = await portalT.queryItems(queryParams);
    if (portalItemReturn.total) {
      setPortal(portalT);
      setOauthChecked(true);
      return portalItemReturn.total
    }
      signOut();
      navigate("/403");
    
  }
};

const checkCredentials = async (
  mapPublic,
  setCredential,
  portalURL,
  esriOauthAppId,
  navigate
) => {
  const oauthInfo = initialize(portalURL, esriOauthAppId);
  let credentialT = await checkCurrentStatus(oauthInfo);
  if (credentialT) {
    setCredential(credentialT);
    return credentialT;
  }
  let cred = await signIn(oauthInfo);
  if (cred) {
    setCredential(cred);
    return cred;
  }
  navigate("/403");
  //setCredential("");
};

const setApiKey=(apiKey)=>{
  esriConfig.apiKey = apiKey;
}
